import React from "react";
import {Card} from 'react-bootstrap';
import STCCardHeader from "./STCCard.Header/STCCard.Header";
import STCCardBody from "./STCCard.Body/STCCard.Body";
import STCCardFooter from "./STCCard.Footer/STCCard.Footer";
import STCCardSubtitle from "./STCCard.Subtitle/STCCard.Subtitle";
import STCCardTitle from "./STCCard.Title/STCCard.Title";
import STCCardText from "./STCCard.Text/STCCard.Text";



function STCCard(props){

    return(
        <Card
            style={props.style}
            className={props.className}
            onClick={props.onClick}

            draggable={props.draggable}
            onDrag={props.onDrag}
            onDragStart={props.onDragStart}
            onDragEnter={props.onDragEnter}
            onDragEnd={props.onDragEnd}
            as={props.as}
            bg={props.bg}
            body={props.body}
            border={props.border}
            text={props.text}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Card>
    )

}

STCCard.Body = STCCardBody;
STCCard.Footer = STCCardFooter;
STCCard.Header = STCCardHeader;
STCCard.Subtitle = STCCardSubtitle;
STCCard.Text = STCCardText;
STCCard.Title = STCCardTitle


export default STCCard;